/* globals google */
import Booking from '../../components/booking';

let markers = [];

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
  let newUrl = url;
  newUrl +=
    (newUrl.indexOf('?') !== -1 ? '&' : '?') +
    Object.keys(params)
      .map((key) => `${key}=${encodeURIComponent(params[key])}`)
      .join('&');

  return newUrl;
}

/**
 * Uses google maps api to render a map
 */
function maps() {
  const infowindow = new google.maps.InfoWindow();

  // reset markers array
  markers = [];

  // Init Italy Map in the center of the viewport
  const latlng = new google.maps.LatLng(41.9027835, 12.4963655);
  const mapOptions = {
    scrollwheel: false,
    zoom: 4,
    center: latlng
  };

  const map = new google.maps.Map($('.map-canvas')[0], mapOptions);
  let mapdiv = $('.map-canvas').attr('data-locations');

  mapdiv = JSON.parse(mapdiv);

  const bounds = new google.maps.LatLngBounds();

  // Customized google map marker icon with svg format
  const markerImg = {
    path: 'M7,0A7,7,0,0,0,0,7c0,5.25,7,13,7,13s7-7.75,7-13A7,7,0,0,0,7,0M7,9.5a2.49,2.49,0,1,1,1.77-.73A2.5,2.5,0,0,1,7,9.5',
    fillColor: '#356d39',
    fillOpacity: 1,
    scale: 2,
    strokeColor: 'white',
    strokeWeight: 1,
    anchor: new google.maps.Point(13, 30),
    labelOrigin: new google.maps.Point(12, 12)
  };

  Object.keys(mapdiv).forEach((key) => {
    const item = mapdiv[key];
    // const lable = parseInt(key, 10) + 1;
    const storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
    const marker = new google.maps.Marker({
      position: storeLocation,
      map,
      title: item.name,
      icon: markerImg
      // label: { text: lable.toString(), color: 'white', fontSize: '16px' }
    });

    marker.addListener('click', () => {
      infowindow.setOptions({
        content: item.infoWindowHtml
      });
      infowindow.open(map, marker);
    });

    // Create a minimum bound based on a set of storeLocations
    bounds.extend(marker.position);

    markers.push(marker);
  });
  // Fit the all the store marks in the center of a minimum bounds when any store has been found.
  if (mapdiv && mapdiv.length !== 0) {
    map.fitBounds(bounds);
  }
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data) {
  const $resultsDiv = $('.results');
  const $mapDiv = $('.map-canvas');
  const hasResults = data.stores.length > 0;

  if (!hasResults) {
    $('.store-locator-no-results').show();
    $('.store-results-number').hide();
  } else {
    $('.store-locator-no-results').hide();
    $('.store-results-number').show();

    // update results number
    $('.store-results-number .results-number').text(data.stores.length);

    if (data.locality) {
      $('.store-results-number .results-location').removeClass('d-none');
      $('.store-results-number .results-location b').text(data.locality);
    } else {
      $('.store-results-number .results-location').addClass('d-none');
    }
  }

  $resultsDiv.empty().data('has-results', hasResults).data('radius', data.radius).data('search-key', data.searchKey);

  $mapDiv.attr('data-locations', data.locations);

  if ($mapDiv.data('has-google-api')) {
    maps();
  } else {
    $('.store-locator-no-apiKey').show();
  }

  if (data.storesResultsHtml) {
    $resultsDiv.append(data.storesResultsHtml);
  }
}

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 * @returns {boolean} false to prevent default event
 */
function search(element) {
  const dialog = element.closest('.in-store-inventory-dialog');
  const spinner = dialog.length ? dialog.spinner() : $.spinner();
  spinner.start();
  const $form = element.closest('.store-locator');
  const radius = $('.results').data('radius');
  let url = $form.attr('action');
  const urlParams = { radius };

  const payload = $form.is('form') ? $form.serialize() : { postalCode: $form.find('[name="postalCode"]').val() };

  url = appendToUrl(url, urlParams);

  $.ajax({
    url,
    type: $form.attr('method'),
    data: payload,
    dataType: 'json',
    success(data) {
      spinner.stop();
      updateStoresResults(data);
      $('.select-store').prop('disabled', true);
    }
  });
  return false;
}

export default class {
  init() {
    if ($('.map-canvas').data('has-google-api')) {
      maps();
    } else {
      $('.store-locator-no-apiKey').show();
    }

    if (!$('.results').data('has-results')) {
      $('.store-locator-no-results').show();
    }

    this.detectLocation();
    this.search();
    this.changeRadius();
    this.selectStore();
    this.updateSelectStoreButton();
    this.initAutocomplete();
    this.resetFilters();
    this.bookingService();
  }

  bookingService() {
    $(document).on('click', '.asyncBooking', function (e) {
      e.preventDefault();
      const storeCard = $(e.currentTarget);
      const url = storeCard.attr('data-bookingurl');
      $.ajax({
        url,
        type: 'get',
        dataType: 'html',
        success(data) {
          $.spinner().stop();
          $('.booking-scripts-container').html(data);
          new Booking().init();
          $('#booking-modal').modal('show');
        }
      });
    });

    // When opened from the GMap, the modal creates a second backdrop and leaves it behind
    $(document).on('shown.bs.modal', '.modal', function () {
      if ($('.modal-backdrop').length > 1) {
        $('.modal-backdrop').not(':first').remove();
      }
    });

    $(document).on('hide.bs.modal', '.modal', function () {
      $('.booking-scripts-container').empty();
      $('.modal-backdrop').remove();
    });
  }

  detectLocation() {
    $('.detect-location').on('click', () => {
      $.spinner().start();
      if (!navigator.geolocation) {
        $.spinner().stop();
        return;
      }

      const showResults = (position) => {
        const $detectLocationButton = $('.detect-location');
        let url = $detectLocationButton.data('action');
        const radius = $('.results').data('radius');
        const urlParams = {
          radius,
          lat: position.coords.latitude,
          long: position.coords.longitude
        };

        url = appendToUrl(url, urlParams);
        $.ajax({
          url,
          type: 'get',
          dataType: 'json',
          success(data) {
            $.spinner().stop();
            updateStoresResults(data);
            $('.select-store').prop('disabled', true);
          }
        });
      };

      const getError = (error) => {
        if (error) {
          $('.detect-location').addClass('disabled');
          $.spinner().stop();
        }
      };

      navigator.geolocation.getCurrentPosition(showResults, getError);
    });
  }

  search() {
    $('.store-locator-container form.store-locator').submit(function (e) {
      e.preventDefault();
      search($(this));
    });
    $('.store-locator-container .btn-storelocator-search[type="button"]').click(function (e) {
      e.preventDefault();
      search($(this));
    });
  }

  changeRadius() {
    $('.store-locator-container .radius').change(function () {
      const radius = $(this).val();
      const searchKeys = $('.results').data('search-key');
      let url = $(this).data('action-url');
      let urlParams = {};

      if (searchKeys.postalCode) {
        urlParams = {
          radius,
          postalCode: searchKeys.postalCode
        };
      } else if (searchKeys.lat && searchKeys.long) {
        urlParams = {
          radius,
          lat: searchKeys.lat,
          long: searchKeys.long
        };
      }

      url = appendToUrl(url, urlParams);
      const dialog = $(this).closest('.in-store-inventory-dialog');
      const spinner = dialog.length ? dialog.spinner() : $.spinner();
      spinner.start();
      $.ajax({
        url,
        type: 'get',
        dataType: 'json',
        success(data) {
          spinner.stop();
          updateStoresResults(data);
          $('.select-store').prop('disabled', true);
        }
      });
    });
  }

  selectStore() {
    $('.store-locator-container').on('click', '.select-store', (e) => {
      e.preventDefault();
      const selectedStore = $(':checked', '.results-card .results');
      const data = {
        storeID: selectedStore.val(),
        searchRadius: $('#radius').val(),
        searchPostalCode: $('.results').data('search-key').postalCode,
        storeDetailsHtml: selectedStore.siblings('label').find('.store-details').html(),
        event: e
      };

      $('body').trigger('store:selected', data);
    });

    $(document).on('click', '.js-store-card', (e) => {
      const storeCard = $(e.currentTarget);
      const index = storeCard.index();

      google.maps.event.trigger(markers[index], 'click');

      $('.js-store-card').removeClass('selected');
      storeCard.addClass('selected');
    });
  }

  updateSelectStoreButton() {
    $('body').on('change', '.select-store-input', () => {
      $('.select-store').prop('disabled', false);
    });
  }

  initAutocomplete() {
    const input = $('#city')[0];
    const autocomplete = new google.maps.places.Autocomplete(input, {
      componentRestrictions: {
        country: ['it']
      },
      types: ['(regions)']
    });

    autocomplete.addListener('place_changed', function () {
      const place = autocomplete.getPlace();
      // let postalCode;
      let locality;
      let radius = 30;

      if (!place.address_components) {
        return;
      }

      // get place info
      for (const component of place.address_components) {
        const componentType = component.types[0];

        if (componentType === 'postal_code') {
          // postalCode = component.short_name;
        }

        if (componentType === 'locality') {
          locality = component.short_name;
        }
      }

      // set radius to 120km for regions
      if (place.types.includes('administrative_area_level_1')) {
        radius = 120;
      }

      // $('#store-postal-code').val(postalCode).attr('value', postalCode);
      $('#store-lat').val(place.geometry.location.lat).attr('value', place.geometry.location.lat);
      $('#store-long').val(place.geometry.location.lng).attr('value', place.geometry.location.lng);
      $('#store-locality').val(locality).attr('value', locality);
      $('#radius').val(radius).attr('value', radius);
    });

    // prevent form submit when interacting with Autocomplete
    $('#city').keydown(function (e) {
      if (e.which === 13 && $('.pac-container:visible').length) return false;
    });
  }

  resetFilters() {
    $('.store-locator-container .js-btn-search-reset').click(function (e) {
      e.preventDefault();

      // reset filters value
      $('[name="service"]:checked').prop('checked', false);
      $('[name="locality"]').val('').attr('value', '');
      $('[name="lat"]').val('').attr('value', '');
      $('[name="long"]').val('').attr('value', '');
      $('[name="city"]').val('').attr('value', '');

      search($(this));
    });
  }
}
